import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

import { storage } from '../../libs';

export interface GuestModel {
  preferredCityId?: number;
  language?: string;
}

export type GuestState = {
  guest: GuestModel | null;
};

const initState: GuestState = {
  guest: storage.guest.get() ?? null,
};

export const useGuest = createStore({
  name: 'guest-state',
  devtools: isDevtoolsEnabled,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setGuest: handler('guest', u => storage.guest.set(u)),
  };
});
